export default __webpack_public_path__ + "static/media/cards.28fc3f50.svg";